// BookingTypesPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const BookingTypesPage = () => <ComingSoon title="Booking types" description="Define the kinds of bookings your hotel accepts." />;

export default BookingTypesPage;
